import { useSelector } from 'react-redux'
import { ClientEventName } from '../api/gqlaxy/gql/generated/graphql'
import { useCreateClientEvent } from '../hooks/useCreateClientEvent'
import { selectHomeUuid } from '../store/selectors/home'
import { useCallback } from 'react'
import { selectAuthedAsClient } from '../store/selectors/auth'

type useCreateHomeClientEventProps = {
  eventName: ClientEventName
  eventProperties?: Record<string, any>
  disableErrorPrompts?: boolean
  listingId?: string
}
// use useCreateHomeClientEventOnce if you want to create the event once per session
export const useCreateHomeClientEvent = ({
  eventName,
  eventProperties = {},
  disableErrorPrompts = true,
  listingId
}: useCreateHomeClientEventProps) => {
  const homeId = useSelector(selectHomeUuid)
  const authedAsCustomer = !useSelector(selectAuthedAsClient)

  const { mutateAsync: createClientEvent } = useCreateClientEvent({ disableErrorPrompts })

  return useCallback(
    (runtimeEventProperties: Record<string, any> = {}) => {
      if (homeId && eventName && !authedAsCustomer) {
        const clientEventInput: {
          homeId: string
          eventName: ClientEventName
          properties: Record<string, any>
          listingId?: string
        } = {
          homeId: homeId,
          eventName: eventName,
          properties: {
            ...eventProperties,
            ...runtimeEventProperties
          }
        }

        if (listingId) {
          clientEventInput.listingId = listingId
        }

        createClientEvent({
          clientEventInput: clientEventInput
        })
      }
    },
    [homeId, eventName, listingId, eventProperties]
  )
}
